import * as SurveyJS from 'survey-react'
import 'survey-react/survey.css'

import * as SurveyJSCreator from 'survey-creator'
import 'survey-creator/survey-creator.css'

import AddressWidget from '~/components/AddressWidget'
import DatePickerWidget from '~/components/DatePickerWidget'
import EddrWidget from '~/components/EddrWidget'
import CaptchaWidget from '~/components/CaptchaWidget'
import { MultiSelectWidget, SingleSelectWidget } from '~/components/CreatableSelectWidget'
import FileUploadWidget from '../FileUploadWidget'

const HULL_ORANGE = '#f28602'
const HULL_ORANGE_2 = '#fac87f'

// SurveyJS Editor Theme Overrides
const styleEditor = () => {
  new SurveyJSCreator.SurveyCreator('surveyCreatorContainer')
  SurveyJSCreator.editorLocalization.locales['xplor'] = {
    ed: {
      testSurvey: 'Preview Form',
      saveSurvey: 'Save Form',
      designer: 'Form Designer'
    }
  }

  SurveyJSCreator.editorLocalization.currentLocale = 'xplor'

  SurveyJSCreator.titleAdorner.pageTitleEditable = false

  const EditorThemeColors = SurveyJSCreator.StylesManager.ThemeColors['default']

  EditorThemeColors['$primary-color'] = HULL_ORANGE
  EditorThemeColors['$secondary-color'] = HULL_ORANGE
  EditorThemeColors['$primary-text-color'] = '#1B1B1B'
  EditorThemeColors['$primary-hover-color'] = HULL_ORANGE
  EditorThemeColors['$selection-border-color'] = HULL_ORANGE

  SurveyJSCreator.StylesManager.applyTheme()
}

// SurveyJS Renderer Theme Overrides
const styleRenderer = () => {
  const SurveyThemeColors = SurveyJS.StylesManager.ThemeColors['default']

  SurveyThemeColors['$main-color'] = HULL_ORANGE
  SurveyThemeColors['$header-color'] = HULL_ORANGE
  SurveyThemeColors['$main-hover-color'] = HULL_ORANGE_2
  SurveyThemeColors['$header-background-color'] = '#4a4a4a'
  SurveyThemeColors['$body-container-background-color'] = '#f8f8f8'
  SurveyThemeColors['$text-color'] = '#1B1B1B'

  SurveyJS.StylesManager.applyTheme()
}

SurveyJS.CustomWidgetCollection.Instance.addCustomWidget(AddressWidget, 'customtype')
SurveyJS.CustomWidgetCollection.Instance.addCustomWidget(DatePickerWidget, 'customtype')
SurveyJS.CustomWidgetCollection.Instance.addCustomWidget(CaptchaWidget, 'customtype')
SurveyJS.CustomWidgetCollection.Instance.addCustomWidget(FileUploadWidget, 'customtype')
SurveyJS.CustomWidgetCollection.Instance.addCustomWidget(EddrWidget, 'customtype')
SurveyJS.CustomWidgetCollection.Instance.addCustomWidget(MultiSelectWidget, 'customtype')
SurveyJS.CustomWidgetCollection.Instance.addCustomWidget(SingleSelectWidget, 'customtype')

styleEditor()
styleRenderer()

export { SurveyJSCreator, SurveyJS }
